
export function isIOSDevice() {
    var userAgent = navigator.userAgent;
    var iosPattern = /iPhone|iPad/i;
    return iosPattern.test(userAgent);
}

export function isMobileDevice() {
    var userAgent = navigator.userAgent;
    var mobilePattern = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;
    if (mobilePattern.test(userAgent))
        return true
    else
        return false;
}